// src/components/RoleProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress, Typography, Container, Paper } from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';

const RoleProtectedRoute = ({ children, requiredRole }) => {
  const { currentUser, userRole, userIsActive, loading } = useAuth();

  // Mostra loading enquanto verifica autenticação
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ color: '#fff', mb: 2 }} />
          <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600 }}>
            Verificando permissões...
          </Typography>
        </Box>
      </Box>
    );
  }

  // Redireciona para login se não estiver autenticado
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Verifica se o usuário está ativo
  if (!userIsActive) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={10}
            sx={{
              p: 5,
              textAlign: 'center',
              borderRadius: 4,
              background: '#ffffff',
            }}
          >
            <BlockIcon sx={{ fontSize: 80, color: '#e53935', mb: 2 }} />
            <Typography variant="h4" sx={{ mb: 2, fontWeight: 700, color: '#2d3748' }}>
              Conta Desativada
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Sua conta foi desativada pelo administrador.
              Entre em contato com o suporte para mais informações.
            </Typography>
          </Paper>
        </Container>
      </Box>
    );
  }

  // Verifica se o usuário tem a role necessária
  if (requiredRole && userRole !== requiredRole) {
    // Se requer admin mas o usuário é comum
    if (requiredRole === 'admin' && userRole === 'user') {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          }}
        >
          <Container maxWidth="sm">
            <Paper
              elevation={10}
              sx={{
                p: 5,
                textAlign: 'center',
                borderRadius: 4,
                background: '#ffffff',
              }}
            >
              <BlockIcon sx={{ fontSize: 80, color: '#f6ad55', mb: 2 }} />
              <Typography variant="h4" sx={{ mb: 2, fontWeight: 700, color: '#2d3748' }}>
                Acesso Negado
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Você não tem permissão para acessar esta página.
                Esta área é restrita para administradores.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Entre em contato com o administrador caso precise de acesso.
              </Typography>
            </Paper>
          </Container>
        </Box>
      );
    }
  }

  // Se passar em todas as verificações, renderiza o componente
  return children;
};

export default RoleProtectedRoute;
